import { addTeam, allTeams, deleteTeam, updateTeam } from '@/utils/request'
import vue from '@/main'

const state = {
  teamList: []
}

const mutations = {
  RESET (state) {
    state.teamList = []
  }
}

const actions = {
  all ({ state }) {
    return new Promise((resolve) => {
      allTeams().then(response => {
        state.teamList = response.data
        resolve(state.teamList)
      })
    })
  },
  teamById ({ commit, state }, id) {
    for (const team of state.teamList) {
      if (team.id === id) return vue.$_.cloneDeep(team)
    }
    return null
  },
  updateOne ({ state }, team) {
    return new Promise((resolve) => {
      updateTeam(team).then(() => {
        for (const cur of state.teamList) {
          if (cur.id === team.id) {
            Object.assign(cur, team)
            break
          }
        }
        resolve()
      })
    })
  },
  add ({ commit, dispatch, state }, team) {
    return new Promise((resolve) => {
      addTeam(team).then((response) => {
        state.teamList.push(response.data)
        resolve(response.data)
      })
    })
  },
  delete ({ commit, dispatch, state }, teamId) {
    return new Promise((resolve) => {
      deleteTeam(teamId).then(() => {
        for (const i in state.teamList) {
          if (state.teamList[i].id === teamId) {
            state.teamList.splice(i, 1)
          }
        }
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
